var _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInboundToSupplier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.33594,
    y1: 12.8043,
    x2: 24.0276,
    y2: 12.8043,
    stroke: "#00B2FF",
    strokeWidth: 1.3348,
    strokeDasharray: "6.67 6.67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboundToSupplier);
export default __webpack_public_path__ + "static/media/inbound-to-supplier.e86363b0b558ad822fb3bf9af8d799bd.svg";
export { ForwardRef as ReactComponent };